import request from 'config/apiConfig';

export const getCTAByMarketer = (payload: {}) => {
  return request.get(`conversion/ctas/marketer`, {
    params: { sort: 'created,desc' }
  });
};

export const getConversionsByMarketer = (payload: {}) => {
  return request.get(`conversion/conversions`, {
    params: { sort: 'created,desc' }
  });
};

export const getTagsByMarketer = () => {
  return request.get(`playlist/tags`, {});
};

export const addTagCategory = (data: any) => {
  return request.post(`/playlist/categories`, data);
};

export const getTagCategoriesByMarketer = () => {
  return request.get(`playlist/categories`, {});
};

export const editCategory = (categoryId: string, categoryName: string) => {
  return request.put(`/playlist/categories/${categoryId}`, { name: categoryName });
};

export const deleteTag = (id: string) => {
  return request.delete(`playlist/tags/${id}`);
};

export const deleteCategory = (id: string) => {
  return request.delete(`playlist/categories/${id}`);
};

export const getContent = (id: string) => {
  return request.get(`playlist/contents/${id}`);
};
export const getContentCTAInfo = (url: string) => {
  return request.get(url);
};
export const getRevisionDetails = (id: string) => {
  return request.get(`content/revisions?contentId=${id}`);
};
